
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import dan from "../../assets/dan.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function DanMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Dán magyar fordító</title>
                <meta name='description' content="Ingyenes dán magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Dán magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/dan-magyar-fordito" />
            </Helmet>
            <h1>Dán magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>
                <div className="sectionhead">
                <h2>A dán nyelvről</h2>
                <img src={dan} alt="A dán zászló"></img>
                </div>
                
                <p>A dán, anyanyelvén "dansk" néven ismert észak-germán nyelv, amelyet elsősorban Dániában és Svédország legdélebbi régiójának egyes részein beszélnek. A dán nyelv a Feröer-szigetek és Grönland egyik hivatalos nyelveként is elismert, amelyek dán közigazgatás alatt álló autonóm területek.</p>

                <p>A dán nyelv gyökerei az ó-norvég nyelvre vezethetők vissza, és sok hasonlóságot mutat más skandináv nyelvekkel, például a svéddel és a norvéggal. A dán nyelvnek azonban vannak olyan hangtani és nyelvtani sajátosságai, amelyek megkülönböztetik a többitől. Jellemzője a dallamos és lágy kiejtés, a magánhangzók finom eltéréseivel és a stød, a glottális stop használatával, amely jellegzetes ritmust kölcsönöz a nyelvnek.</p>
             
                <p>A dán nyelvtan összetett nyelvtani szerkezetet alkalmaz, három nemet (hím-, nő- és semleges) és két nyelvtani számot (egyes és többes szám). A főnevek és melléknevek a mondatban betöltött szerepük alapján változtatják alakjukat. Emellett a dán szókincs változatos, és vegyesen tartalmaz anyanyelvi szavakat és más nyelvekből, különösen az alnémetből és a franciából származó kölcsönszavakat.</p>

                <p>Bár a dán nyelvet elsősorban Dániában beszélik, más skandináv nyelvek beszélői is megértik, mivel a dán nyelvek között kölcsönös az érthetőség. A dán nyelv gazdag irodalmi hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Hans Christian Andersen és Søren Kierkegaard, akik hozzájárultak a dán kulturális örökséghez.</p>

                <p>Az utóbbi években a dán nyelv magáévá tette a technológiai fejlődést, és a digitális platformokon és a médiában való használata egyre bővült. Ugyanakkor a dán lakosság körében magas az angol nyelvtudás, és az angol nyelvet gyakran használják üzleti és tudományos környezetben. Ennek ellenére a dán nyelv továbbra is a nemzeti identitás fontos szimbóluma, és jelentős szerepet játszik a dán kultúrában és társadalomban.</p>
       
                <div className="sectionbottom">
                    <Link to="/magyar-dan-fordito">Magyar dán fordító</Link>

                    <img src={dan} alt="dán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
       
       
            </section>
        </>

    )
}

export default DanMagyar;